module.exports = __webpack_public_path__ + "img/cover7-1920.c9211005.jpg";